import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = {
  class: "w-72 h-screen",
  style: {"margin-bottom":"-125px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl bg-opacity-80 bg-blue-200" }, "Filter", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Reuse type", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "ALL" }, "All", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "w-full h-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("header", { class: "bg-opacity-40 bg-gray-200 z-10" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl" }, "Department of Reuse"),
    /*#__PURE__*/_createElementVNode("h2", null, "- under development / data widely incomplete -")
  ])
], -1)
const _hoisted_10 = { class: "flex-none w-72 order-3 hidden lg:block z-10 overflow-y-auto h-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GraphView = _resolveComponent("GraphView")!
  const _component_EditButton = _resolveComponent("EditButton")!
  const _component_EditDialog = _resolveComponent("EditDialog")!
  const _component_TopFive = _resolveComponent("TopFive")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_Legend = _resolveComponent("Legend")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          class: "",
          name: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedFilter) = $event))
        }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reuseTypes, (type) => {
            return (_openBlock(), _createElementBlock("option", {
              key: type[0],
              value: type[0]
            }, _toDisplayString(type[1]), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.selectedFilter]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_GraphView, {
            reuseData: $setup.reuseData,
            filter: $setup.selectedFilter
          }, null, 8, ["reuseData", "filter"])
        ])
      ]),
      _createVNode(_component_EditButton, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => {$setup.editDialogVisible = true;})
      }),
      ($setup.editDialogVisible)
        ? (_openBlock(), _createBlock(_component_EditDialog, { key: 0 }))
        : _createCommentVNode("", true),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_TopFive, {
          class: "z-10",
          reuseData: $setup.reuseData
        }, null, 8, ["reuseData"]),
        _createVNode(_component_Stats, {
          reuseData: $setup.reuseData,
          filter: $setup.selectedFilter
        }, null, 8, ["reuseData", "filter"]),
        _createVNode(_component_Legend)
      ])
    ])
  ]))
}